import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TListCheckbookChecksRequest,
  TListCheckbookChecksResponse,
} from "./listCheckbookChecks.schema";

export const listCheckbookChecks = (axios: IAxiosInstance) => {
  return async (params?: TListCheckbookChecksRequest) => {
    const response = await axios.noRetry.get<
      IApiResponse<TListCheckbookChecksResponse>
    >("/api/checkbookChecks", {
      params: { ...params },
      withCredentials: true,
    });

    if (response.data.success) {
      return response.data.data;
    }

    throw new Error("Failed to list Checkbook checks");
  };
};
